<div class="address_body">
  <div class="top_panel">
    <h3>Payout Information</h3>
    <span (click)="close()" class="close">
      <img src="https://cdn.elitehw.com/images/cross.webp" />
    </span>
  </div>
  <div class="formarea">
    <div class="inputprt">
        <label>Card Type</label>
        <div class="input_txt">{{data?.cardType}}</div>
    </div>
    <div class="inputprt">
        <label>Card Number</label>
        <div class="input_txt">{{data?.cardType === 'American Express' ? 'XXXX XXXXXX X' : 'XXXX XXXX XXXX
          '}}{{data?.lastFourDigit}}</div>
    </div>
    <div class="amount_section">
      <div class="amount">
        {{data?.amount | currency}}
      </div>
      <button (click)="close()" class="cancel">Close</button>
    </div>
    
  </div>
</div>